import { SysPermissionTreeVo, UserInfoVo } from '@/services/type';
import { Key, ReactNode } from 'react';

export interface Tab {
  label: ReactNode;
  key: Key;
  addonAfter?: string;
  id?: string;
  copy?: string;
}

export interface Menu extends SysPermissionTreeVo {
  hidden?: boolean;
}

export interface State {
  lang: string;
  tabItems: Tab[];
  activeTabKey?: Key;
  menus: Menu[] | null;
  userInfo: UserInfoVo | null;
  pagePaths: string[] | null;
  isDecrypt?: string;
}

export enum MenuType {
  Directory,
  Page,
  Button,
}
